<template>
  <div class="order-block order-policyholder" id="companyInsuranceInfo">
    <div class="title">投保人信息</div>

    <el-form class="insurance-order" :model="insuranceData" ref="dataForm" :rules="rules" :inline="true" label-position="top">
      <div class="content">
        <el-form-item label="" prop="applicant.cname">
          <div class="form-item-label" solt="label">
            企业名称<span class="required">*</span>
          </div>
          <!-- 更改去掉自动获取焦点部分 -->
          <el-input v-model.trim="insuranceData.applicant.cname"
            placeholder="请输入" :maxlength="30" @input="calculateCompanyPinyin(insuranceData.applicant, true, 100)"></el-input>
        </el-form-item>

        <el-form-item label="" prop="applicant.card_code">
          <!-- 更改部分 -->
          <div class="form-item-label" solt="label" v-if="supportCompanyStructureCode">
            组织机构代码<span class="required">*</span>
          </div>
          <div class="form-item-label" solt="label" v-else>
            统一社会信用代码<span class="required">*</span><span class="sub-label">（营业执照左上角代码）</span>
          </div>
          <el-input v-model.trim="insuranceData.applicant.card_code" placeholder="请输入" :maxlength="18" @input="toUpperCase(insuranceData.applicant, 'card_code')"></el-input>
        </el-form-item>

        <el-form-item class="w-100" label="" prop="applicant.ename">
          <div class="form-item-label" solt="label">
            企业名称拼音<span class="required">*</span>
          </div>
          <el-input v-model.trim="insuranceData.applicant.ename" placeholder="请输入" :maxlength="100"></el-input>
        </el-form-item>

        <el-form-item label="" prop="applicant.mobile">
          <div class="form-item-label" solt="label">
            手机号码<span class="required">*</span>
          </div>
          <el-input v-model.trim="insuranceData.applicant.mobile" placeholder="请输入" :maxlength="11"></el-input>
        </el-form-item>
      </div>
    </el-form>


  </div>
</template>


<script>
import 'pinyin4js';
import { rules } from '@/pages/insurance/services/insurance-info-service';
import utils from '@/libs/utils';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rules,
      insuranceData: undefined,
    };
  },
  computed: {
    // 投保人为公司，支持的证件类型
    supportCompanyStructureCode() {
      // 10组织机构代码证 14统一信用代码证
      return this.insuranceData.policy_holder_type_set && this.insuranceData.policy_holder_type_set.includes(10);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.insuranceData)) {
          this.insuranceData = utils.deepCopy(val);
        }
      },
      deep: true,
      immediate: true,
    },
    insuranceData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  methods: {
    // 根据输入的公司名称计算拼音
    calculateCompanyPinyin(item, needEmptyEname, length) {
      if (item.cname && (needEmptyEname || !item.ename)) {
        let text = item.cname;
        text = text.replace(/[()（）]/g, '');
        item.ename = PinyinHelper.convertToPinyinString(text, '#', PinyinFormat.WITHOUT_TONE)
          .split('#')
          .map(pin => pin.substring(0, 1).toUpperCase() + pin.substring(1))
          .join('')
          .substring(0, length);
        this.$forceUpdate();
      }
    },
    // 转换大写
    toUpperCase(item, field) {
      item[field] = item[field] ? item[field].toUpperCase().substring(0, 18) : '';
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject('#companyInsuranceInfo');// 抛id出去，做滚动
          }
        });
      });
    },

  },
};
</script>


<style lang="less" scoped>
.order-block {
  .title{
    padding-left: 24px;
    display: flex;
    align-items: center;
    background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
    height: 44px;
    color: #2F333D;
    font-size: 18px;
    font-weight: 600;
    &.personal {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 24px;
      .self-btn {
        font-size: 14px;
        color: #5F666E;
        line-height: 20px;
        font-weight: normal;
        display: flex;
        align-items: center;
        /deep/ .el-switch {
          transform: scale(0.7);
          margin-right: 2px;
        }
      }
    }
  }
  .content {
    padding: 20px 24px;
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
    &.self-insure-content {
      display: flex;
      flex-direction: column;
      .applicant-list {
        display: flex;
        flex-wrap: wrap;
        .applicant-item {
          padding: 0 46px;
          height: 28px;
          line-height: 28px;
          background: #FAFBFC;
          border-radius: 2px;
          border: 1px solid #DEE2E6;
          margin-right: 16px;
          font-size: 14px;
          color: #2F333D;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/company-insurance-info.vue